module.exports = __webpack_public_path__ + "img/dazi.4a04f77a.png";